import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {formatCurrency} from '@/utilities/helpers'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardEconomicSearchParams} from '../../types'
import {useGetDashboardAnalytics} from '../../query/useGetDashboardAnalytics'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'

export const DashboardCalculatedCostsCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardEconomicSearchParams)
    const {data, isLoading} = useGetDashboardAnalytics({
        fields: ['billedAccesses', 'costs', 'otherCosts'],
        ...searchParams
    })

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:calculated_costs')} />
    }

    return (
        <DashboardCard title={t('dashboard:calculated_costs')}>
            <Text palette="neutral" shade="900" size="textXl" weight={700}>
                {formatCurrency(data?.costs?.total ?? 0)}
            </Text>
        </DashboardCard>
    )
}
